import AnimatedCounter from "@/components/AnimatedCounter";
import type { Totals } from "../utils/acvRcv";

interface SummaryCardsProps {
  totals: Totals;
}

export default function SummaryCards({ totals }: SummaryCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card
        label="Replacement cost (RCV)"
        sub="What it costs to buy new today"
        value={totals.rcv}
        accent="emerald"
      />
      <Card
        label="Insurance pays (ACV)"
        sub="What an ACV policy would cut you a check for"
        value={totals.acv}
        accent="amber"
      />
      <Card
        label="The gap"
        sub="Out-of-pocket if you only have ACV"
        value={totals.gap}
        accent="rose"
        highlight
      />
    </div>
  );
}

interface CardProps {
  label: string;
  sub: string;
  value: number;
  accent: "emerald" | "amber" | "rose";
  highlight?: boolean;
}

function Card({ label, sub, value, accent, highlight }: CardProps) {
  const accentMap = {
    emerald: "text-emerald-600",
    amber: "text-amber-600",
    rose: "text-rose-600",
  } as const;
  return (
    <div
      className={`rounded-2xl border p-5 bg-card transition-all ${
        highlight ? "border-rose-200 bg-rose-50/40 shadow-sm" : "border-border"
      }`}
    >
      <div className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </div>
      <div className={`mt-2 text-3xl md:text-4xl font-editorial tabular-nums ${accentMap[accent]}`}>
        <AnimatedCounter value={Math.round(value)} prefix="$" duration={700} />
      </div>
      <div className="mt-1.5 text-xs text-muted-foreground leading-snug">{sub}</div>
    </div>
  );
}
